import styled from 'styled-components';

export const StyledWrapper = styled.div`
  position: absolute;
  z-index: 10;
  top: -24px;
`;

export const StyledClickablePill = styled.span`
  cursor: pointer;
  background-color: #e3e3e3;
  border-radius: 20px;
  margin-right: 2px;
  padding: 0 8px;

  &:hover {
    & a {
      text-decoration: underline;
    }
  }

  & a {
    color: #00286a;
    text-decoration: none;
  }
`;

export const StyledNotClickablePill = styled.span`
  cursor: default;
  background-color: #e3e3e3;
  border-radius: 20px;
  padding: 0 8px;
`;
